import BasicRepository, {ListArgs} from "./basicRepository";
import Client from "../client";
import InterruptionResource from "client/resources/interruptionResource";

interface InterruptionListArgs extends ListArgs {
    regarding?: string;
    pendingOnly?: boolean;
}

class InterruptionRepository extends BasicRepository<InterruptionResource, InterruptionResource, InterruptionListArgs> {
    constructor(client: Client) {
        super("Interruptions", client);
    }
    submit(interruption: InterruptionResource, result: any) {
        return this.client.post(interruption.Links["Submit"], result);
    }
    takeResponsibility(interruption: InterruptionResource) {
        return this.client.put(interruption.Links["Responsible"]);
    }
}

export default InterruptionRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/interruptionRepository.ts